module.exports = __webpack_public_path__ + "b88c6d8615f38c3bef4f5240f02f8ef0.jpg";